/**
 * Barras horizontales para comparar magnitudes: activo, pasivo, patrimonio.
 *
 * Barras y no una dona. Comparar dos sectores de un círculo obliga a juzgar
 * ángulos, que es la comparación que peor hace el ojo; comparar dos barras
 * apoyadas en la misma línea base es la que mejor hace. Con siete tarjetas
 * iguales —que es lo que había— no hay comparación en absoluto: hay siete
 * números que el lector tiene que ordenar de cabeza.
 */

import { formatMillions, formatMoney } from "../format";
import { type Cifra, cifra } from "./escala";

export interface Magnitud {
  id: string;
  label: string;
  /** Crudo de la API: puede venir como cadena. Se convierte al entrar. */
  value: Cifra;
  slot: 1 | 2 | 3;
  /** Renglones que componen la magnitud; se listan debajo, sin barra. */
  partes?: { label: string; value: Cifra }[];
}

export function BarrasComposicion({ filas }: { filas: Magnitud[] }) {
  const limpias = filas.map((f) => ({ ...f, value: cifra(f.value) }));
  const tope = Math.max(...limpias.map((f) => Math.abs(f.value ?? 0)), 1);
  return (
    <div className="viz-composicion">
      {limpias.map((fila) => (
        <div className="viz-magnitud" key={fila.id}>
          <div className="viz-magnitud-cabeza">
            <span className="viz-magnitud-rotulo">{fila.label}</span>
            <span className="viz-magnitud-cifra num">{formatMillions(fila.value)}</span>
          </div>
          <div className="viz-riel">
            <span
              className={`viz-barra serie-${fila.slot}`}
              style={{ width: `${(Math.abs(fila.value ?? 0) / tope) * 100}%` }}
            />
          </div>
          {fila.partes && (
            <dl className="viz-partes">
              {fila.partes.map((parte) => (
                <div key={parte.label}>
                  <dt>{parte.label}</dt>
                  <dd className="num">{formatMoney(parte.value)}</dd>
                </div>
              ))}
            </dl>
          )}
        </div>
      ))}
    </div>
  );
}
